/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function StarIconOpen(props: IconProps) {
	const { color = 'yellow' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-351 -523)">
					<path d="M361 526.02l1.987 4.372.3.662.725.066 4.227.384-3.321 3.344-.466.468.125.648.864 4.497-3.812-2.325-.65-.397-.652.397-3.799 2.316.887-4.476.128-.65-.467-.473-3.32-3.35 4.232-.383.724-.066.3-.662L361 526.02m0-3.02l-3.125 6.875-6.875.625 5.189 5.234L354.75 543l6.228-3.796 6.223 3.796-1.396-7.271L371 530.5l-6.875-.625L361 523z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default StarIconOpen;
